import React, {FC} from 'react'

type Props = {
  amount?: number
}

const UserAmountCell: FC<Props> = ({amount}) => {
  console.log(amount);
  return <div className='badge badge-light fw-bolder fs-5'>{amount}</div>
}

export default UserAmountCell
